"use strict";
// Copyright (c) StrangeBee 2023
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../../../../constants");
const utils_1 = require("../../../../utils/");
const regexTemplate = /\:([a-zA-Z]+)((?=\/|\?|\&)*)/g;
const defaultTemplate = /{([\s\S]+?)}/g;
const interpolate = (str, templateContext, regexTemplate = defaultTemplate) => str
    .replace(regexTemplate, (match, submatch) => {
    return templateContext[submatch] || '';
})
    .replace(/[^=&|?]+=(&|$)/g, '')
    .replace(/&$/, '');
class AxiosSender {
    constructor(baseURL) {
        this.setTestInstance = (instance) => (this.axiosInstance = instance);
        this.post = ({ endpoint, body = {}, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            const url = this.buildUrl(endpoint);
            try {
                const { data } = yield this.axiosInstance.post(url, body, config);
                return data;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.patch = ({ endpoint, body = {}, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            const url = this.buildUrl(endpoint);
            try {
                const { data } = yield this.axiosInstance.patch(url, Object.assign({}, body), config);
                return data;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.put = ({ endpoint, body = {}, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            const url = this.buildUrl(endpoint);
            try {
                const { data } = yield this.axiosInstance.put(url, Object.assign({}, body), config);
                return data;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.delete = ({ endpoint, body, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            const url = this.buildUrl(endpoint);
            try {
                const { data } = yield this.axiosInstance.request(Object.assign({ method: 'DELETE', data: body, url }, config));
                return data;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.getFullResponse = ({ endpoint, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            const url = this.buildUrl(endpoint);
            try {
                const result = yield this.axiosInstance.get(url, config);
                return result;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.get = ({ endpoint, config = {} }) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const { data, headers } = yield this.getFullResponse({ endpoint, config });
                return ((_a = config.headers) === null || _a === void 0 ? void 0 : _a['x-th-session-config'])
                    ? Object.assign(Object.assign({}, data), { $headers: {
                            'x-th-session-timeout': headers['x-th-session-expiration-date'],
                            'x-th-session-warning': headers['x-th-session-expiration-warning'],
                            'x-th-inactivity-timeout': headers['x-th-session-inactivity-timeout'],
                            'x-th-inactivity-warning': headers['x-th-session-inactivity-warning'],
                        } })
                    : data;
            }
            catch (e) {
                (0, utils_1.errorManager)(e);
            }
        });
        this.buildUrl = ({ url, params }) => interpolate(url, params, regexTemplate);
        this.axiosInstance = axios_1.default.create({
            baseURL,
            xsrfCookieName: 'THE-HIVE-XSRF-TOKEN',
            xsrfHeaderName: 'X-THE-HIVE-XSRF-TOKEN',
            withCredentials: true,
        });
        this.baseURL = baseURL;
    }
    static getInstance(baseURL = constants_1.API_URL) {
        if (!AxiosSender.instance) {
            AxiosSender.instance = new AxiosSender(baseURL);
        }
        return AxiosSender.instance;
    }
    getBaseUrl() {
        return this.baseURL;
    }
    getInterceptors() {
        return this.axiosInstance.interceptors;
    }
}
exports.default = AxiosSender;
